import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { reducedMotion } from "../../../utils/device";

export type ButtonVariant = "primary" | "ghost" | "outline" | "dark" | "light";

interface IStyledButton {
  variant: ButtonVariant;
}

const variants = (
  variant: ButtonVariant,
  theme: any
): FlattenSimpleInterpolation => {
  switch (variant) {
    case "ghost":
      return css`
        background: transparent;
        border-color: #728195;
        color: ${theme.colors.white};
      `;
    case "outline":
      return css`
        background: transparent;
        border-color: ${theme.colors.brand.surface.border};
        color: ${theme.colors.brand.deep};
      `;
    case "dark":
      return css`
        background: ${theme.colors.brand.deep};
        color: ${theme.colors.white};
      `;
    case "light":
      return css`
        background: ${theme.colors.white};
        color: ${theme.colors.brand.deep};
      `;
    case "primary":
    default:
      return css`
        background: ${theme.colors.brand.action};
        color: ${theme.colors.brand.deep};

        &:hover {
          background: ${theme.colors.brand.cyan};
        }
      `;
  }
};

export const buttonStyles = (
  variant: ButtonVariant,
  theme: any
): FlattenSimpleInterpolation => css`
  align-items: center;
  border: 1px solid transparent;
  border-radius: ${theme.layout.radius.button};
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 650;
  gap: 12px;
  justify-content: center;
  line-height: 1.3;
  min-height: 50px;
  padding: 12px 22px;
  text-align: center;
  text-decoration: none;
  transition: background 0.15s ease, transform 0.15s ease;
  ${variants(variant, theme)};

  &:hover {
    transform: translateY(-2px);
  }

  svg {
    height: 18px;
    width: 18px;
  }

  @media ${reducedMotion} {
    &:hover {
      transform: none;
    }
  }
`;

export const StyledButton = styled.button<IStyledButton>(
  ({ theme, variant }) => css`
    cursor: pointer;
    ${buttonStyles(variant, theme)};
  `
);

export const StyledButtonLink = styled.a<IStyledButton>(
  ({ theme, variant }) => css`
    ${buttonStyles(variant, theme)};
  `
);

export const TextLink = styled.a(
  ({ theme }) => css`
    align-items: center;
    color: inherit;
    display: inline-flex;
    font-size: 14px;
    font-weight: ${theme.typography.weights.medium};
    gap: 8px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-underline-offset: 5px;
    }

    svg {
      height: 18px;
      width: 18px;
    }
  `
);
